<!-- <div class="h-full flex flex-col p-4 w-full text-sm">
    <form [formGroup]="addStoryForm" class="mat-form-container bg-white p-6 rounded-lg mb-6" (ngSubmit)="onSubmit()">

        <div class="row">
          <mat-form-field  class="half-width">
            <mat-label>Story Heading</mat-label>
            <input matInput formControlName="StoryHeading" maxlength="130">
            <mat-hint align="end">{{addStoryForm.get('StoryHeading')?.value?.length || 0}} / 130</mat-hint>
            <mat-error *ngIf="addStoryForm.get('StoryHeading')?.hasError('required')">Story heading is required</mat-error>
          </mat-form-field>
      
          <mat-form-field  class="half-width">
            <mat-label>Story Subheading</mat-label>
            <input matInput formControlName="StorySubheading">
            <mat-error *ngIf="addStoryForm.get('StorySubheading')?.hasError('required')">Subheading is required</mat-error>
          </mat-form-field>
        </div>
      
        <div class="row">
          <mat-form-field  class="half-width">
            <mat-label>Story Synopsis</mat-label>
            <input matInput formControlName="StorySynopsis" maxlength="50">
            <mat-hint align="end">{{addStoryForm.get('StorySynopsis')?.value?.length || 0}} / 50</mat-hint>
            <mat-error *ngIf="addStoryForm.get('StorySynopsis')?.hasError('required')">Synopsis is required</mat-error>
          </mat-form-field>
      
          <mat-form-field  class="half-width">
            <mat-label>Main Image Alt Text</mat-label>
            <input matInput formControlName="mainImageAltText">
            <mat-error *ngIf="addStoryForm.get('mainImageAltText')?.hasError('required')">Alt Text is required</mat-error>
          </mat-form-field>
        </div>
      
        <div class="row">
          <mat-form-field  class="half-width">
            <mat-label>Image Caption 1</mat-label>
            <input matInput formControlName="ImageCaption1">
            <mat-error *ngIf="addStoryForm.get('ImageCaption1')?.hasError('required')">Caption is required</mat-error>
          </mat-form-field>
      
          <mat-form-field  class="half-width">
            <mat-label>Category</mat-label>
            <mat-select formControlName="category_id">
              <mat-option value="1">Politics</mat-option>
              <mat-option value="2">Sports</mat-option>
              <mat-option value="3">Entertainment</mat-option>
            </mat-select>
            <mat-error *ngIf="addStoryForm.get('category_id')?.hasError('required')">Category is required</mat-error>
          </mat-form-field>
        </div>
      
        <div class="row">
          <mat-form-field  class="half-width">
            <mat-label>State</mat-label>
            <input matInput formControlName="state">
            <mat-error *ngIf="addStoryForm.get('state')?.hasError('required')">State is required</mat-error>
          </mat-form-field>
      
          <mat-form-field  class="half-width">
            <mat-label>City</mat-label>
            <input matInput formControlName="city">
            <mat-error *ngIf="addStoryForm.get('city')?.hasError('required')">City is required</mat-error>
          </mat-form-field>
        </div>
      
        <div class="row">
          <mat-form-field  class="half-width">
            <mat-label>Story Meta Title</mat-label>
            <input matInput formControlName="storyMetaTitle" maxlength="130">
            <mat-hint align="end">{{addStoryForm.get('storyMetaTitle')?.value?.length || 0}} / 130</mat-hint>
            <mat-error *ngIf="addStoryForm.get('storyMetaTitle')?.hasError('required')">Meta Title is required</mat-error>
          </mat-form-field>
      
          <mat-form-field  class="half-width">
            <mat-label>Meta Description</mat-label>
            <textarea matInput formControlName="storyMetaDescription" maxlength="210" rows="3"></textarea>
            <mat-hint align="end">{{addStoryForm.get('storyMetaDescription')?.value?.length || 0}} / 210</mat-hint>
            <mat-error *ngIf="addStoryForm.get('storyMetaDescription')?.hasError('required')">Meta Description is required</mat-error>
          </mat-form-field>
        </div>
      
        <div class="row full">
          <mat-form-field  class="full-width">
            <mat-label>Full Story</mat-label>
            <textarea matInput formControlName="FullStory" rows="5"></textarea>
            <mat-error *ngIf="addStoryForm.get('FullStory')?.hasError('required')">Full Story is required</mat-error>
          </mat-form-field>
        </div>
      
        <button mat-raised-button color="primary" type="submit" [disabled]="addStoryForm.invalid">Submit</button>
      </form>
      
</div> -->
<form [formGroup]="biddingForm" (ngSubmit)="submit()" class="bidding-form" novalidate>

  <h2>Tender Document Preparation</h2>

  <div formGroupName="tenderDetails">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Tender Title</mat-label>
      <input matInput formControlName="title" />
      <mat-error *ngIf="biddingForm.get('tenderDetails.title')?.touched && biddingForm.get('tenderDetails.title')?.invalid">
        Title is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Tender Reference Number</mat-label>
      <input matInput formControlName="referenceNo" />
      <mat-error *ngIf="biddingForm.get('tenderDetails.referenceNo')?.touched && biddingForm.get('tenderDetails.referenceNo')?.invalid">
        Reference number is required.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="half-width">
      <mat-label>Issue Date</mat-label>
      <input matInput type="date" formControlName="issueDate" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="half-width">
      <mat-label>Submission Deadline</mat-label>
      <input matInput type="date" formControlName="submissionDeadline" />
    </mat-form-field>

    <div class="file-upload">
      <label>Upload Tender Document:</label>
      <input type="file" (change)="onFileChange($event)" />
    </div>
  </div>

  <h2>Vendor Evaluation</h2>

  <div formArrayName="vendors">
    <div *ngFor="let vendor of vendors.controls; let i = index" [formGroupName]="i" class="vendor-section">
      <mat-form-field class="full-width">
        <mat-label>Vendor Name</mat-label>
        <input matInput formControlName="vendorName" />
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>Bid Amount</mat-label>
        <input matInput type="number" formControlName="bidAmount" />
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>Evaluation Score (%)</mat-label>
        <input matInput type="number" formControlName="evaluationScore" />
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let option of selectionOptions" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-icon-button color="warn" (click)="removeVendor(i)" aria-label="Remove Vendor">
        <mat-icon>delete</mat-icon>
      </button>

      <mat-divider></mat-divider>
    </div>
  </div>

  <button mat-raised-button color="accent" (click)="addVendor()" type="button">Add Vendor</button>

  <div class="actions">
    <button mat-raised-button color="primary" type="submit">Submit Bidding Details</button>
  </div>

</form>



  